const images = {
  logo_operator: require('./images/LOGO_OPERATOR.png'),
  scan_help_ticket_illustration: require('./images/ticket_illustration.png'),
  game_logo_default: (require('./images/Game_Default_Thumnail.png'))
}

export default images
